import { render } from "./ChangeBgpPeerForNetwork.vue?vue&type=template&id=bb0d938c&scoped=true"
import script from "./ChangeBgpPeerForNetwork.vue?vue&type=script&lang=js"
export * from "./ChangeBgpPeerForNetwork.vue?vue&type=script&lang=js"

import "./ChangeBgpPeerForNetwork.vue?vue&type=style&index=0&id=bb0d938c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0d938c"]])

export default __exports__